import cloneDeep from 'lodash/cloneDeep';
import { getOnlyCardPath } from './get-only-cn-card-path';
/**
 * schema 比较前预处理
 * @param oldSchema 缓存的 schema
 * @param newSchema 最新的 schema
 * @param cnCardCount 卡片数量
 * @returns 处理后用于比较的schema
 */
export function prepareSchemaForComparison(oldSchema, newSchema, cnCardCount) {
    const oldSchemaClone = cloneDeep(oldSchema);
    const newSchemaClone = cloneDeep(newSchema);
    if (cnCardCount > 1) {
        // 多卡片情况：删除 smartAiForm 字段
        delete oldSchemaClone.properties.smartAiForm;
    }
    else if (cnCardCount === 1) {
        // 单卡片情况：获取唯一卡片路径并删除 desc 属性
        const cardPath = getOnlyCardPath(oldSchemaClone.properties);
        if (cardPath) {
            const oldCard = oldSchemaClone.properties[cardPath];
            const newCard = newSchemaClone.properties[cardPath];
            if (oldCard && oldCard['x-component-props']) {
                delete oldCard['x-component-props'].desc;
            }
            if (newCard && newCard['x-component-props']) {
                delete newCard['x-component-props'].desc;
            }
        }
    }
    else {
        // 无卡片情况：删除 smart_ai_form_subCard_CnFormGrid 字段
        delete oldSchemaClone.properties.smart_ai_form_subCard_CnFormGrid;
    }
    return { oldSchemaClone, newSchemaClone };
}
